import {REJECTED_QC_HISTORY} from "./ActionType";

export default function rejectedQCHistoryReducer(state = [], action) {
  const {type, payload} = action;

  switch (type) {
    case REJECTED_QC_HISTORY:
      return (state = payload);

    default:
      return state;
  }
}